import { useState, useEffect } from 'react';

const NoSSR = props => {
  const { children } = props;
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    setIsShow(true);
  }, []);
  if (isShow) return children;
  return null;
};

export default NoSSR;
